import { Action, createReducer, on } from '@ngrx/store';
import { listToDictionary } from '@symphony-solo/shared/utils/src';
import { loadTaxRateShiftsAction, loadTaxRateShiftsErrorAction, loadTaxRateShiftsSuccessAction } from './taxrate-shifts.actions';
import { TaxRateShiftsState } from './taxrate-shifts.state';

const initialState = new TaxRateShiftsState();

const reducer = createReducer(
  initialState,
  on(loadTaxRateShiftsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(loadTaxRateShiftsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.taxrateShifts = listToDictionary(payload.taxrateShifts, 'id');
    return newState;
  }),
  on(loadTaxRateShiftsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function taxRateShiftsReducer(state: TaxRateShiftsState | null, action: Action) {
  return reducer(state, action);
}
